export const REQUEST_LIST_CLOUD_KEYS = 'cloudKey/REQUEST_LIST_CLOUD_KEYS';
export const SET_CLOUD_KEYS = 'cloudkey/SET_CLOUD_KEYS';
export const REQUEST_UNLOCK_WITH_CLOUD_KEY =
  'cloudkey/REQUEST_UNLOCK_WITH_CLOUD_KEY';
